import { CIcon } from '~/icons/types'

export const ciContainers: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M22.975 11.27h-2.22l-7.48-2.72c.295-.322.459-.743.46-1.18A1.73 1.73 0 0 0 12.5 5.71v-.45h.79a.726.726 0 0 0 .73-.72V3.45a.716.716 0 0 0-.72-.72h-2.57a.726.726 0 0 0-.73.72v1.08a.734.734 0 0 0 .73.73h.79v.87a.493.493 0 0 0 .5.49.75.75 0 1 1-.75.75.5.5 0 0 0-.5-.49.491.491 0 0 0-.49.49c.001.437.165.858.46 1.18l-7.47 2.72H1.035a.983.983 0 0 0-.99.98v8.03a.986.986 0 0 0 .99.99h21.94a.985.985 0 0 0 .98-.99v-8.03a.982.982 0 0 0-.98-.98Zm-10.97-2.14 5.87 2.14H6.135l5.87-2.14Zm-8.17 9.9a.49.49 0 0 1-.98 0V13.5a.49.49 0 1 1 .98 0v5.53Zm2.89 0a.49.49 0 0 1-.98 0V13.5a.49.49 0 1 1 .98 0v5.53Zm2.89 0a.5.5 0 0 1-.5.49.491.491 0 0 1-.49-.49V13.5a.49.49 0 0 1 .84-.347.5.5 0 0 1 .15.348v5.53Zm2.88 0a.49.49 0 0 1-.98 0V13.5a.49.49 0 0 1 .98 0v5.53Zm2.89 0a.49.49 0 0 1-.98 0V13.5a.49.49 0 0 1 .98 0v5.53Zm2.88 0a.49.49 0 0 1-.98 0V13.5a.49.49 0 0 1 .98 0v5.53Zm2.89 0a.49.49 0 0 1-.98 0V13.5a.49.49 0 0 1 .98 0v5.53Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'containers',
  type: 'solid'
}
